var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#40649F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.31081 4.07812C8.29575 4.07812 10.7308 4.54781 13.0427 6.219C15.3546 7.89019 14.3162 10.2392 13.7992 10.6976C13.2817 11.1561 9.2385 11.7613 8.9865 12.1798C8.7345 12.5977 8.44088 14.2031 7.18087 14.2031C5.92087 14.2031 5.33475 12.9263 5.03775 12.1854C4.73963 11.4446 4.35938 10.1897 4.35938 8.43019C4.35938 6.67069 5.11875 4.07812 7.31081 4.07812ZM6.45019 8.73787C5.68912 8.79469 5.33081 9.91069 5.41125 11.1268C5.49169 12.3429 6.40856 13.3791 6.9615 13.3791C7.51444 13.3791 8.334 12.6444 8.17088 11.0559C8.00719 9.46688 7.21125 8.6805 6.45019 8.73787ZM10.7207 6.75787C9.65475 6.34331 8.08031 5.96644 8.57756 7.056C8.74519 7.42219 8.88019 8.05894 8.98313 8.96569C10.9654 8.81944 12.1556 8.58319 12.5522 8.25694C13.1468 7.76869 11.7861 7.173 10.7207 6.75787Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrv);
export default __webpack_public_path__ + "static/media/crv.31f222287ccdaeea5f27e1573596df69.svg";
export { ForwardRef as ReactComponent };